import { ModalController } from './modal-controller';

class VirtualAccountModalController extends ModalController {
  static targets = [
    'modal',
    'bankName',
    'branchName',
    'accountNumber',
    'accountHolderName',
  ]

  afterOpen(event) {
    // openModal の action がバインドされたボタン自身（data 属性の保持元）を確実に参照する
    const { bankName, branchName, accountNumber, accountHolderName } = event.currentTarget.dataset;

    this.bankNameTarget.textContent        = bankName        || '';
    this.branchNameTarget.textContent      = branchName      || '';
    this.accountNumberTarget.textContent   = accountNumber   || '';
    this.accountHolderNameTarget.textContent = accountHolderName || '';
  }
}

// Registered in customer.js
export { VirtualAccountModalController };
